import { fontsize12, poppins500 } from 'theme/common.style';

export const stageCont = {
  ...poppins500,
  ...fontsize12,
  background: 'green',
  padding: '4px 8px',
  borderRadius: '5px',
  color: 'white',
};

export const counterAlignColumProp = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
export const counterSubProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '10px',
};
